export default __webpack_public_path__ + "static/media/amexipac.b59b45b5.svg";